import script from "./BaseSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&setup=true&lang=js"

import "./BaseSpinner.vue?vue&type=style&index=0&id=c2fe846c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2fe846c"]])

export default __exports__